// ============================================
// CUSTOM FIELDS COPY MODAL - 3 BOTÕES (Sim, Não, Cancelar)
// ============================================

import React from 'react'
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  Button,
  Typography,
  Box
} from '@mui/material'

const CustomFieldsCopyModal = ({ 
  open, 
  onClose, 
  title, 
  message, 
  confirmText = "Sim",
  rejectText = "Não",
  cancelText = "Cancelar",
  type = "copy",
  details = null,
  disableBackdropClick = false
}) => {
  const handleConfirm = () => {
    onClose('confirm')  // 'confirm' = Sim
  }

  const handleReject = () => {
    onClose('reject')   // 'reject' = Não (continua sem copiar)
  }

  const handleCancel = () => {
    onClose('cancel')   // 'cancel' = Cancelar (volta organização original)
  }

  return (
    <Dialog
      open={open}
      // Impedir fechamento ao clicar fora
      onClose={(event, reason) => {
        if (reason === 'backdropClick' && disableBackdropClick) {
          return
        }
        onClose('cancel')
      }}
      aria-labelledby="custom-fields-dialog-title"
      aria-describedby="custom-fields-dialog-description"
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '90vh',
          height: 'auto',
          minHeight: '300px',
        }
      }}
    >
      <DialogTitle id="custom-fields-dialog-title">
        <Box display="flex" alignItems="center" gap={1}>
          <span style={{ fontSize: '24px' }}>
            {type === 'copy' ? '📋' : '🆕'}
          </span>
          <Typography variant="h6">
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent 
        dividers
        sx={{ 
          maxHeight: '500px',
          height: 'auto',
          minHeight: '200px',
          overflow: 'auto',
          padding: '16px 24px',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        }}
      >
        <DialogContentText id="custom-fields-dialog-description" component="div">
          <Typography variant="body1" sx={{ mb: 2 }}>
            {message}
          </Typography>
          
          {details && (
            <Box sx={{ 
              mt: 2, 
              p: 2, 
              backgroundColor: '#f5f5f5', 
              borderRadius: 1,
              fontSize: '14px',
            }}>
              {details}
            </Box>
          )}
        </DialogContentText>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, pt: 0 }}>
        {/* Botão Cancelar - à esquerda */}
        <Button 
          onClick={handleCancel} 
          color="inherit"
          variant="outlined"
        >
          {cancelText}
        </Button>
        
        {/* Espaço flex para separar os botões */}
        <Box sx={{ flex: 1 }} />
        
        {/* Botão Não */}
        <Button 
          onClick={handleReject} 
          color="inherit"
          variant="text"
        >
          {rejectText}
        </Button>
        
        {/* Botão Sim - à direita */}
        <Button 
          onClick={handleConfirm} 
          color="primary" 
          variant="contained"
          autoFocus
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CustomFieldsCopyModal
